import jsonToAst from 'json-to-ast';

type Location = jsonToAst.Location;

const typeKeys = {
  query: 'queries',
  mutation: 'mutations',
  shape: 'shapes'
};

export function getLineNumber(
  schema: string,
  type: 'query' | 'mutation' | 'shape',
  name: string
): Location | undefined {
  const ast = jsonToAst(schema);
  const typeKey = typeKeys[type];
  let typeObject: jsonToAst.ValueNode | undefined;
  if (ast.type !== 'Object') {
    throw new Error('Schema is not an object');
  }

  for (const property of ast.children) {
    if (property.key.value === typeKey) {
      typeObject = property.value;
      break;
    }
  }

  if (typeObject === undefined || typeObject.type !== 'Object') {
    throw new Error(`${typeKey} is not an object`);
  }

  for (const property of typeObject.children) {
    if (property.key.value === name) {
      return property.loc;
    }
  }
}
